var map = {
	"./Card/Card.tsx": 51149,
	"./Card/samples/basic.tsx": 75214,
	"./Card/samples/image.tsx": 63235,
	"./Card/samples/interactive.tsx": 57341,
	"./Card/samples/sample.tsx": 80373,
	"./ColorContrastInspector/ColorContrastInspector.tsx": 93958,
	"./ColorContrastInspector/internal/Cell.tsx": 89984,
	"./ColorContrastInspector/samples/basic.tsx": 47966,
	"./ColorContrastInspector/samples/extended.tsx": 28266,
	"./Exhibits/Exhibits.tsx": 67726,
	"./Exhibits/samples/basic.tsx": 92774,
	"./Figma/Figma.tsx": 34736,
	"./Figma/samples/basic.tsx": 59488,
	"./FontFamilyMatrix/FontFamilyMatrix.tsx": 85212,
	"./FontFamilyMatrix/samples/basic.tsx": 56679,
	"./Image/Image.tsx": 13855,
	"./Image/samples/basic.tsx": 4054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 70019;
module.exports = webpackContext;